/* eslint-disable */

import axios from 'axios';
import storage from '../storage';

const endpoint = 'auth';

export default {
    async authenticate({ email /*string*/, password /*string*/ }) {
        const request = {
            email,
            password,
            grant_type: "client_credentials",
        };

        const response = await axios.post(`${endpoint}/authenticate`, request);
        const oAuthResponse = response.data;
        storage.local.setAccessToken(oAuthResponse.access_token);
    },

    endUserSession(vueComponent) {
        storage.local.removeAccessToken();
        vueComponent.$router.push({ path: "/login" });
        setTimeout(() => window.location.reload(), 500);
    },

    async refresh() {
        // TODO Add refresh token request
    }
}
